/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Rag_Priority_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "The AI now prioritises information from your organisation's linked knowledge spaces over its general training data." |
*
* @param {Audit_Details_Rag_Priority_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_rag_priority_enabled_desc = /** @type {((inputs?: Audit_Details_Rag_Priority_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Rag_Priority_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI priorisiert jetzt Informationen aus den verlinkten Wissensspaces Ihrer Organisation gegenüber ihrem allgemeinen Trainingswissen.")
	return /** @type {LocalizedString} */ ("The AI now prioritises information from your organisation's linked knowledge spaces over its general training data.")
});